import { createI18n } from 'vue-i18n';
import en from '@/locales/en';
import ja from '@/locales/ja';

export const supportedLocales = {
  en: { name: 'English' },
  ja: { name: '日本語' },
};

export const i18n = createI18n({
  legacy: false,
  locale: import.meta.env.VITE_I18N_LOCALE ?? 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE ?? 'en',
  messages: {
    en,
    ja,
  },
});
